(function () {
  if (window.voiceNoteControllerInitialized) {
    return;
  }
  window.voiceNoteControllerInitialized = true;

  const formatTime = (value) => {
    if (value === undefined || value === null || Number.isNaN(value) || !isFinite(value)) {
      return '--:--';
    }

    const minutes = Math.floor(value / 60);
    const seconds = Math.floor(value % 60);
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  const pauseOtherPlayers = (currentAudio) => {
    document.querySelectorAll('.voice-note__audio').forEach((audioEl) => {
      if (audioEl !== currentAudio && !audioEl.paused) {
        audioEl.pause();
      }
    });
  };

  const initPlayer = (root) => {
    if (!root || root.dataset.voiceNoteReady === 'true') {
      return;
    }
    root.dataset.voiceNoteReady = 'true';

    const audio = root.querySelector('.voice-note__audio');
    const playButton = root.querySelector('[data-voice-note-toggle]');
    const track = root.querySelector('[data-voice-note-progress]');
    const trackFill = root.querySelector('[data-voice-note-progress-fill]');
    const progressDot = root.querySelector('[data-voice-note-progress-dot]');
    const elapsedEl = root.querySelector('[data-voice-note-elapsed]');
    const durationEl = root.querySelector('[data-voice-note-duration]');

    if (!audio || !playButton || !track || !trackFill || !elapsedEl || !durationEl) {
      return;
    }

    const updateDuration = () => {
      const total = audio.duration || 0;
      durationEl.textContent = formatTime(total);
      elapsedEl.textContent = formatTime(audio.currentTime || 0);
    };

    const updateProgress = () => {
      if (!audio.duration) {
        return;
      }

      const percent = (audio.currentTime / audio.duration) * 100;
      trackFill.style.setProperty('--voice-note-progress', `${percent}%`);
      if (progressDot) {
        progressDot.style.setProperty('--voice-note-progress', `${percent}%`);
      }

      elapsedEl.textContent = formatTime(audio.currentTime);
    };

    const updateState = () => {
      const isPlaying = !audio.paused && !audio.ended;
      root.classList.toggle('is-playing', isPlaying);
      playButton.setAttribute('aria-label', isPlaying ? 'Sprachnotiz pausieren' : 'Sprachnotiz abspielen');
    };

    playButton.addEventListener('click', () => {
      if (audio.paused) {
        pauseOtherPlayers(audio);
        audio.play();
      } else {
        audio.pause();
      }
    });

    track.addEventListener('click', (event) => {
      if (!audio.duration) {
        return;
      }
      const rect = track.getBoundingClientRect();
      const ratio = (event.clientX - rect.left) / rect.width;
      const clamped = Math.min(Math.max(ratio, 0), 1);
      audio.currentTime = clamped * audio.duration;
    });

    audio.addEventListener('loadedmetadata', () => {
      updateDuration();
      updateProgress();
    });

    audio.addEventListener('play', () => {
      updateState();
    });

    audio.addEventListener('pause', () => {
      updateState();
    });

    audio.addEventListener('timeupdate', updateProgress);

    audio.addEventListener('ended', () => {
      updateState();
      trackFill.style.setProperty('--voice-note-progress', '0%');
      if (progressDot) {
        progressDot.style.setProperty('--voice-note-progress', '0%');
      }
      elapsedEl.textContent = formatTime(audio.duration);
    });

    if (audio.readyState >= 1) {
      updateDuration();
    }

    updateState();
  };

  const initAllPlayers = () => {
    document.querySelectorAll('[data-voice-note]').forEach(initPlayer);
  };

  document.addEventListener('DOMContentLoaded', initAllPlayers);
  document.addEventListener('shopify:section:load', initAllPlayers);
  document.addEventListener('shopify:block:select', initAllPlayers);
})();
